import { request } from '@/utils';
import { RequestConfig } from '@/utils/request';

export const login = async (
  data: {
    message: string;
    data: string;
    key: string;
    chainType: string;
    authType?: string;
    protocolTag?: string;
    address?: string;
  },
  errorHandler: (e: Error) => void
): Promise<any> => {
  return request({
    url: '/account/login',
    method: 'POST',
    data,
    errorHandler
  });
};

export async function fetchUser(options?: RequestConfig): Promise<any> {
  return request({
    url: '/account/me',
    ...options
  });
}

//
// export const getNonce = async () => {
//   return request({
//     url: '/account/nonce'
//   });
// };
//
// export const verifyMessage = async (data: { message: any; signature: string }) => {
//   return request({
//     url: '/account/verify',
//     method: 'POST',
//     data
//   });
// };
//
export const logout = async (): Promise<any> => {
  return request({
    url: '/account/signout',
    method: 'POST'
  });
};
